import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash-es";
import CheckboxIcon from "../../components/checkboxicon/CheckboxIcon";
import { useId } from "../../helpers";
const Checkbox = props => {
  const {
    name,
    label,
    onBlur,
    disabled,
    style
  } = props;
  const id = useId();
  const labelId = `tui-checkbox-${id}`;
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-checkbox",
    style: style
  }, /*#__PURE__*/React.createElement(CheckboxIcon, {
    id: labelId,
    onChange: value => {
      props.onCheck(value);
      props.onChange({
        target: {
          name,
          value,
          checked: value
        }
      });
    },
    onBlur: onBlur,
    checked: props.checked,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: labelId
  }, label)), props.tip ? /*#__PURE__*/React.createElement("div", {
    className: "tui-checkbox-tip"
  }, props.tip) : null);
};
Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.node.isRequired,
  onCheck: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.object
};
Checkbox.defaultProps = {
  checked: false,
  name: undefined,
  onChange: noop,
  onBlur: noop,
  disabled: false,
  onCheck: noop,
  style: {}
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map